import React, { memo } from 'react'
import { withStyles, Paper, Typography, Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import RouterPath from 'libs/RouterPath';
import Title from 'components/Title';

const style = theme => ({
	root: {
		padding: theme.spacing(2),
		'&>*': {
			'&:not(:first-child)': {
				marginTop: theme.spacing(1)
			}
		}
	}
})

function TourTooltip({
	classes,
	step,
	primaryProps,
	tooltipProps,
	isLastStep,
	onEnd,
	changePage,
}) {
	const { title, content, href } = step;

	const handleNextClick = (e) => {
		if (href) {
			RouterPath.redirect(href)
		}
		primaryProps.onClick(e)
	}

	return (
		<Paper className={classes.root} {...tooltipProps}>
			<Title align='center'>
				{title}
			</Title>
			<Typography variant='body1' align='justify'>
				{content}
			</Typography>
			{!isLastStep &&
				<Button
					variant='contained'
					color='primary'
					fullWidth
					onClick={handleNextClick}
				>
					{Tr('further')}
				</Button>
			}
			<Button
				variant='outlined'
				color='primary'
				fullWidth
				onClick={onEnd}
			>
				{Tr('exit')}
			</Button>
		</Paper>
	)
}

TourTooltip.propTypes = {
	classes: PropTypes.any,
}

TourTooltip.defaultProps = {
}

export default memo(withStyles(style)(TourTooltip));